import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=56e6eb07"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"
import style0 from "./customSelect.vue?vue&type=style&index=0&id=56e6eb07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports